import { Button } from "@luciad/ria-sample-common/components/button/Button";
import { ButtonGroup } from "@luciad/ria-sample-common/components/ButtonGroup";
import { Modal } from "@luciad/ria-sample-common/components/Modal";
import { addReference, isValidReferenceIdentifier, parseWellKnownText } from "@luciad/ria/reference/ReferenceProvider";
import React, { CSSProperties } from "react";
import { ButtonWithModal } from "../components/ButtonWithModal";

interface ReferenceButton {
  text: string;
  referenceKey: string;
}

const PROJECTION_BUTTONS: ReferenceButton[] = [
  {
    text: "3D (EPSG:4978)",
    referenceKey: "epsg:4978"
  },
  {
    text: "Web Mercator (EPSG:3857)",
    referenceKey: "EPSG:3857"
  },
  {
    text: "CRS:84",
    referenceKey: "CRS:84"
  },
  {
    text: "EPSG:27700",
    referenceKey: "EPSG:27700"
  }
];

let wktBritish = 'PROJCS["OSGB36 / British National Grid",GEOGCS["Ordnance Survey of Great Britain 1936",DATUM["Ordnance Survey of Great Britain 1936",SPHEROID["Airy_1830",6377563.396,299.3249646],TOWGS84[446.448,-125.157,542.06,0.15,0.247,0.8420000000000001,-20.488999999956903]],PRIMEM["Greenwich",0.0],UNIT["Degrees",0.017453292519943295]],PROJECTION["Transverse_Mercator"],PARAMETER["latitude_of_origin",49.0],PARAMETER["longitude_of_origin",-2.0],PARAMETER["scale_factor",0.9996012717],PARAMETER["false_northing",-100000.0],PARAMETER["false_easting",400000.0],UNIT["Meters",1.0],AXIS["Easting",EAST],AXIS["Northing",NORTH]]';
let referenceBritish = parseWellKnownText(wktBritish);
addReference(referenceBritish, "EPSG:27700");

interface Props {
  show: boolean;
  onHide: () => void;
}

const reloadWithKnownReferenceKey = (referenceKey: string) => {
  var params = [
    "webgl=true",
    "reference=" + referenceKey
  ];

  window.location.href =
    "http://" +
    window.location.host +
    window.location.pathname +
    '?' + params.join('&');
}

const reloadWithWKT = (wkt: string) => {
  const encodedWkt = encodeURIComponent(wkt);
  const referenceKey = "WKT"

  var params = [
    "webgl=true",
    "reference=" + referenceKey,
    "wkt=" + encodedWkt
  ];

  window.location.href =
    "http://" +
    window.location.host +
    window.location.pathname +
    '?' + params.join('&');
}

export const ChooseReferenceModal = ({ show, onHide }: Props) => {
  return (
    <Modal title="Choose reference" show={show} onHide={onHide}>
      <ButtonGroup vertical={true}>
        {PROJECTION_BUTTONS.map(btn => {
          return (
            <Button key={btn.referenceKey} onClick={() => reloadWithKnownReferenceKey(btn.referenceKey)} >
              {btn.text}
            </Button>);
        })}

        <span> </span>

        <ButtonWithModal label="Enter EPSG code"
          modal={(show, onHide) => <EnterCustomReferenceModal show={show} onHide={onHide} />} />

        <ButtonWithModal label="Enter custom WKT"
          modal={(show, onHide) => <EnterWKTModal show={show} onHide={onHide} />} />

        {/* <Button onClick={() => reloadWithIputReference()}>
          LOAD CUSTOM REFERENCE
        </Button>
        <input type="text" id="referenceText" /> */}
      </ButtonGroup>
    </Modal>
  )
}

export const EnterCustomReferenceModal = ({ show, onHide }: Props) => {
  const reloadWithIputReference = () => {
    const inputField = document.getElementById("referenceText") as HTMLInputElement;
    const referenceText = inputField.value;

    if (isValidReferenceIdentifier(referenceText)) {
      reloadWithKnownReferenceKey(referenceText);
    }
    else {
      const epsgCode = referenceText.toLowerCase().replace("epsg:", "");
      fetch("https://epsg.io/" + epsgCode + ".wkt")
        .then(x => x.text())
        .then(wkt => {
          reloadWithWKT(wkt);
        })
        .catch(error => {
          const message = "LuciadRIA does not have this key (" + referenceText + ") preconfigured.\n"
            + "(to increase the loading speed it only holds a subset)\n"
            + "The input could also not be used to retrieve a reference from https://epsg.io/\n"
            + "Please use an existing EPSG code or create a custom WKT (OGC Well Known Text)."
          alert(message);
          console.log(message);
        });
    }
  }

  const inputStyle: CSSProperties = {
    width: '44%'
  };

  return (
    <Modal title="Enter EPSG code" show={show} onHide={onHide}>
      <ButtonGroup vertical={true}>
        <input style={inputStyle} type="text" id="referenceText" />
        <Button onClick={() => reloadWithIputReference()}>
          OK
        </Button>
      </ButtonGroup>
    </Modal>
  )
}

export const EnterWKTModal = ({ show, onHide }: Props) => {
  const reloadWithIputWKT = () => {
    const inputField = document.getElementById("referenceText") as HTMLInputElement;
    const referenceText = inputField.value;
    reloadWithWKT(referenceText);
  }

  const inputStyle: CSSProperties = {
    width: '88%'
  };

  return (
    <Modal title="Enter custom WKT" show={show} onHide={onHide}>
      <ButtonGroup vertical={true}>
        <textarea rows={3} style={inputStyle} id="referenceText" />
        <Button onClick={() => reloadWithIputWKT()}>
          OK
        </Button>
      </ButtonGroup>
    </Modal>
  )
}